import { createTheme } from '@mui/material/styles';

export const slatePalette = {
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a",
};

export const greenPalette = {
    50: "#f0fdf4",
    100: "#dcfce7",
    200: "#bbf7d0",
    300: "#86efac",
    400: "#4ade80",
    500: "#22c55e",
    600: "#16a34a",
    700: "#15803d",
    800: "#166534",
    900: "#14532d",
};

type SlatePalette = typeof slatePalette;
type GreenPalette = typeof greenPalette;

declare module "@mui/material/styles" {
    interface Theme {
        slate: SlatePalette;
        green: GreenPalette;
    }
    interface ThemeOptions {
        slate?: SlatePalette;
        green?: GreenPalette;
    }
}

const Theme = createTheme({
    palette: {
        primary: { main: '#096acb' },
        secondary: { main: '#ef870f' },
        success: { main: '#10B981' },
        error: { main: '#DF332D' },
    },
    slate: slatePalette,
    green: greenPalette,
});

export default Theme;
